const getYoutubeVideoId = (str: string) => {
  const match = str.match(/^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/);
  return match && match[5];
};

export {
  getYoutubeVideoId,
};
